import { Spin } from 'antd'
import styled from 'styled-components'

const C = styled.div`
    background: #fff;
    padding: 20px 40px;
    overflow-y: auto;
`

const Container = (
    {children, loading = false}: {children: any, loading?: boolean}
) => {
    // if(loading) {
        return <Spin spinning={loading} tip="Loading...">
            <C>
                
                {
                    children
                }
            </C>
        </Spin>
    // }
    // return <C>
    //     {
    //         children
    //     }
    // </C>
}

export default Container